/* eslint-disable complexity */
import { itemsPerPage, pageNum } from 'appConstants';

export const actions = {
  updateFilter: 'update_filter',
  updateUsersTableFilter: 'update_users_table_filter',
  resetFilter: 'reset_filter',
  resetTeamUsersFilter: 'reset_team_users_filter',
  updateParams: 'update_params',
  updateUsersTableParams: 'update_users_table_params',
  setSnackbarMessage: 'set_snackbar_message',
  setShowImportModal: 'set_show_import_modal',
  setTeamData: 'set_team_data',
  setShouldFetchUsers: 'set_should_fetch_users',
  setTeamsTableSearchFocused: 'set_teams_search_focused',
  setTeamsUsersTableSearchFocused: 'set_teams_users_table_search_focused',
};

const initialSortColumn = 'name';
const initialTeamSortId = 1;

const teamsInitialState = {
  teamsTableFilter: { nameSearchValue: '', idSearchValue: '', fqdnSearchValue: '' },
  teamsTableParams: {
    page: pageNum.ZERO,
    rowsPerPage: itemsPerPage,
    sort: `+${initialSortColumn}`,
    field: initialSortColumn,
    sortDirection: 'asc',
    sortColumnId: initialTeamSortId,
  },
  teamsUsersTableFilter: { userName: '', lastName: '', phoneNumber: '' },
  teamsUsersTableParams: {
    page: pageNum.ZERO,
    rowsPerPage: itemsPerPage,
    sort: `+${initialSortColumn}`,
    field: initialSortColumn,
    sortDirection: 'asc',
    sortColumnId: initialTeamSortId,
  },
  backgroundEventsParams: {
    page: pageNum.ZERO,
    rowsPerPage: itemsPerPage,
    sort: `+${initialSortColumn}`,
    field: initialSortColumn,
    sortDirection: 'asc',
    sortColumnId: initialTeamSortId,
  },
  teamData: {
    teamName: '',
    parentTeam: {},
    teamId: '',
    teamFqdn: '',
    teamOptOutMessage: '',
  },
  snackbarMessage: '',
  showImportModal: false,
  shouldFetchUsers: true,
  teamsTableSearchFocused: false,
  teamsUsersTableSearchFocused: false,
};

function teamsReducer(state, action) {
  switch (action.type) {
    case actions.updateFilter: {
      const { payload } = action;

      return {
        ...state,
        teamsTableFilter: { ...state.teamsTableFilter, ...payload },
      };
    }
    case actions.updateUsersTableFilter: {
      const { payload } = action;

      return {
        ...state,
        teamsUsersTableFilter: { ...state.teamsUsersTableFilter, ...payload },
      };
    }
    case actions.resetFilter: {
      return {
        ...state,
        teamsTableFilter: teamsInitialState.teamsTableFilter,
      };
    }
    case actions.resetTeamUsersFilter: {
      return {
        ...state,
        teamsUsersTableFilter: teamsInitialState.teamsUsersTableFilter,
      };
    }
    case actions.updateParams: {
      const { payload } = action;

      return {
        ...state,
        teamsTableParams: { ...state.teamsTableParams, ...payload },
      };
    }
    case actions.updateUsersTableParams: {
      const { payload } = action;

      return {
        ...state,
        teamsUsersTableParams: { ...state.teamsUsersTableParams, ...payload },
      };
    }
    case actions.setSnackbarMessage: {
      const { payload } = action;

      return {
        ...state,
        snackbarMessage: payload,
      };
    }
    case actions.setShowImportModal: {
      const { open } = action;

      return {
        ...state,
        showImportModal: open,
      };
    }
    case actions.setShouldFetchUsers: {
      const { fetch } = action;

      return {
        ...state,
        shouldFetchUsers: fetch,
      };
    }
    case actions.setTeamData: {
      const { payload } = action;

      return {
        ...state,
        teamData: { ...state.teamData, ...payload },
      };
    }
    case actions.setTeamsTableSearchFocused: {
      const { focused } = action;

      return {
        ...state,
        teamsTableSearchFocused: focused,
      };
    }
    case actions.setTeamsUsersTableSearchFocused: {
      const { focused } = action;

      return {
        ...state,
        teamsUsersTableSearchFocused: focused,
      };
    }
    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}

export { teamsReducer, teamsInitialState };
